import get from 'lodash/get';

export const themeProp =
  (path: string | string[]) =>
  ({ theme } = {}) =>
    get(theme, path);
